export default {
    Owner: 1,
    OwnerAndAdmin: 3,
    All: 7,
};
